import React, { useContext, useState, useEffect } from 'react'
import { Context } from "../../../Context"
import { AddOfferView } from "../../views"
import { SimpleLoading, ModalUtil } from "../../pures"
import { OfferService, CatalogService } from "../../../services"
import { AddOfferIconFirst, AddOfferIconSecond, AddPublicityIconSecond as AddOfferIconThird } from '../../../assets/logos/icons'
import { useTranslation } from "react-i18next"
import { useHistory } from 'react-router-dom'


const AddOfferAction = (props) => {
  const { t } = props
  const { t: translModal } = useTranslation('offer', { keyPrefix: 'modal' })
  const { t: transl } = useTranslation('offer', { keyPrefix: 'offerAddValidations' })
  const apiUrl = process.env.REACT_APP_ETICKET_API
  const offerService = new OfferService(apiUrl)
  const catalogService = new CatalogService(apiUrl)
  const token = JSON.parse(localStorage.getItem('token')).accessToken

  const [initialLoading, setInitialLoading] = useState(false)
  const [catalogInsert, setCatalogInsert] = useState([])
  const [productsCatalog, setProductsCatalog] = useState([])
  const modalUtil = new ModalUtil()
  const history = useHistory()

  //first data
  const [name, setName] = useState('')
  const [startDate, setStartDate] = useState('')
  const [typeOffer, setTypeOffer] = useState('Promoción')
  const [keyIdentifier, setKeyIdentifier] = useState('')
  const [discountDetails, setDiscountDetails] = useState('')
  const [termsAndConditions, setTermsAndConditions] = useState('')
  const [endDate, setEndDate] = useState('')
  const [description, setDescription] = useState('')
  const [image, setImage] = useState(null)
  const [imageSrc, setImageSrc] = useState(null)

  const handleImageUpload = (file) => {
    if (file) {
      const reader = new FileReader()
      reader.onloadend = () => {
        setImageSrc(reader.result)
      }
      reader.readAsDataURL(file)
    } else {
      setImageSrc(null)
    }
  }

  //second data
  const [consumerPreferencesSelected, setConsumerPreferencesSelected] = useState([])
  const [gendersSelected, setGendersSelected] = useState([])
  const [agesSelected, setAgesSelected] = useState({ start: 10, end: 80 })
  const [branchOfficesSelected, setBranchOfficesSelected] = useState([])
  const [productsSelected, setProductsSelected] = useState([])

  const validationsFirstPage = () => {
    if (!name || !keyIdentifier || !typeOffer || !description || !startDate || !endDate || !image || !imageSrc) throw new Error(transl('validationsInputFirstPage'))
    if (startDate > endDate) throw new Error(transl('datesValidation'))
  }

  const validationsSecondPage = () => {
    if (!discountDetails.length) throw new Error(transl('discountBenefitValidation'))
    if (!termsAndConditions.length) throw new Error(transl('termsAndConditionsValidation'))
    if (!productsSelected.length) throw new Error(transl('productsValidation'))
  }

  const validationsThirdPage = () => {
    if (!consumerPreferencesSelected.length) throw new Error(transl('preferencesValidation'))
    if (!gendersSelected.length) throw new Error(transl('genderValidation'))
    if (agesSelected.start > agesSelected.end) throw new Error(transl('agesValidation'))
    if (!branchOfficesSelected.length) throw new Error(transl('branchOfficeValidation'))
  }

  const isValidInfoPage = (page) => {
    try {
      const tableValidations = {
        1: validationsFirstPage,
        2: validationsSecondPage,
        3: validationsThirdPage
      }

      tableValidations[page]()
      return true
    } catch (error) {
      modalUtil.showModal('error', error.message, t("modal.pure.title.error"))
      return false
    }
  }

  const sendData = async () => {
    modalUtil.showModal('loading', t("modal.pure.loading.message"), t("modal.pure.loading.title"))

    try {
      const consumerPreferencesIds = consumerPreferencesSelected.map(({ id }) => id)
      const branchOfficesIds = branchOfficesSelected.map(({ id }) => id)
      const typeOfferId = catalogInsert.typeOffer.find((typeOfferSelected) => typeOfferSelected.name === typeOffer).id
      const genderIds = gendersSelected.map((genderToShow) => {
        const genderObject = catalogInsert.gender.find((gendersSelected) => gendersSelected.name === genderToShow)
        return genderObject.id
      })

      let newOfferData = new FormData()
      newOfferData.append("name", name)
      newOfferData.append("description", description)
      newOfferData.append("minAge", agesSelected.start)
      newOfferData.append("maxAge", agesSelected.end)
      newOfferData.append("startDate", startDate)
      newOfferData.append("endDate", endDate)
      newOfferData.append("typeOfferId", typeOfferId)
      newOfferData.append("keyIdentifier", keyIdentifier)
      newOfferData.append("detailsInfo", discountDetails)
      newOfferData.append("termsAndConditions", termsAndConditions)
      newOfferData.append("products", JSON.stringify(productsSelected))
      newOfferData.append("image", image)
      newOfferData.append("consumerPreferencesIds", JSON.stringify(consumerPreferencesIds))
      newOfferData.append("genderIds", JSON.stringify(genderIds))
      newOfferData.append("branchOfficeIds", JSON.stringify(branchOfficesIds))

      const newOffer = await offerService.setOffer(newOfferData, token)
      if (newOffer && newOffer.data && Number(newOffer.statusCode) === 200) {
        modalUtil.showModal('success', translModal('successAdd'), t("modal.pure.title.success"), () => history.push('/offers'))
      } else {
        modalUtil.showModal('error', translModal('errorAdd'), t("modal.pure.title.error"))
      }
    } catch (error) {
      modalUtil.showModal('error', translModal('errorAdd'), t("modal.pure.title.error"))
    }
  }

  const steps = [
    {
      image: AddOfferIconFirst,
      title: 'Datos',
      next: 'Continuar',
      back: 'Salir',
    },
    {
      image: AddOfferIconSecond,
      title: 'Documentos',
      next: 'Finalizar',
      back: 'Regresar',
    },
    {
      image: AddOfferIconThird,
      title: 'Documentos',
      next: 'Finalizar',
      back: 'Regresar',
    },
  ]

  useEffect(() => {
    getCatalogInsert()
  }, [])

  const getCatalogInsert = async () => {
    try {
      const catalogInsert = await catalogService.getCatalogInsert(token, 'offer')
      setCatalogInsert(catalogInsert)
      setProductsCatalog(catalogInsert.products)
      setInitialLoading(false)
    } catch (error) {
      props.setShowError(true)
      setInitialLoading(false)
    }
  }

  const deleteDiscountProductList = (deleteProduct) => {
    setProductsSelected(productsSelected.filter((product) => product.id !== deleteProduct.id))

    const originalCatalog = [...catalogInsert.products]

    const updatedProducts = originalCatalog.filter(el =>
      !(productsSelected.some(selected => selected.id === el.id) && el.id !== deleteProduct.id)
    );
    setTimeout(() => {
      setProductsCatalog(updatedProducts);
    }, 1000);

  }

  return (
    <>
      {
        initialLoading ?
          <div className="loading">
            <SimpleLoading />
          </div> : (
            <AddOfferView
              {...props}
              steps={steps}
              catalogInsert={catalogInsert}
              name={name}
              setName={setName}
              startDate={startDate}
              setStartDate={setStartDate}
              endDate={endDate}
              setEndDate={setEndDate}
              description={description}
              setDescription={setDescription}
              image={image}
              setImage={setImage}
              consumerPreferencesSelected={consumerPreferencesSelected}
              setConsumerPreferencesSelected={setConsumerPreferencesSelected}
              gendersSelected={gendersSelected}
              setGendersSelected={setGendersSelected}
              agesSelected={agesSelected}
              setAgesSelected={setAgesSelected}
              branchOfficesSelected={branchOfficesSelected}
              setBranchOfficesSelected={setBranchOfficesSelected}
              productsCatalog={productsCatalog}
              setProductsCatalog={setProductsCatalog}
              sendData={sendData}
              handleImageUpload={handleImageUpload}
              imageSrc={imageSrc}
              productsSelected={productsSelected}
              setProductsSelected={setProductsSelected}
              typeOffer={typeOffer}
              setTypeOffer={setTypeOffer}
              keyIdentifier={keyIdentifier}
              setKeyIdentifier={setKeyIdentifier}
              discountDetails={discountDetails}
              setDiscountDetails={setDiscountDetails}
              termsAndConditions={termsAndConditions}
              setTermsAndConditions={setTermsAndConditions}
              deleteDiscountProductList={deleteDiscountProductList}
              isValidInfoPage={isValidInfoPage}
            >
            </AddOfferView >
          )
      }
    </>
  )
}

function AddOfferActionContainer(props) {
  const { t } = useTranslation()
  const { setShowError } = useContext(Context)
  return (
    <AddOfferAction {...props} t={t} setShowError={setShowError} />
  )
}

export { AddOfferActionContainer as default }